.keyboard {
  font-size: var(--font-size-sm);
  line-height: normal;
}
